function objectToSortedEntries(obj: any): [string, any][] {
  if (!obj) return [];
  if (typeof obj !== `object`) return obj;

  return Object.entries(obj)
    .map((entry) => {
      const [key, value] = entry;

      return typeof value === `object`
        ? ([key, objectToSortedEntries(value)] as [string, any])
        : entry;
    })
    .sort();
}

export function objEquals(k1: any, k2: any) {
  if (k1 === k2) return true;
  if (!k1 || !k1) return false;
  return (
    objectToSortedEntries(k1).toString() ===
    objectToSortedEntries(k2).toString()
  );
}

// cookies

export function setCookie(name: string, value: string, days: number) {
  let expires = ``;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=` + date.toUTCString();
  }
  document.cookie = name + `=` + (value || ``) + expires + `; path=/`;
}

export function getCookie(name: string) {
  const nameEQ = name + `=`;
  const ca = document.cookie.split(`;`);
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]!;
    while (c.charAt(0) === ` `) c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function scrollToRef(ref: React.RefObject<HTMLDivElement>) {
  ref?.current?.scrollIntoView();
}
